module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp3_5010.3a607b11.png";